import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useRoleViewEffectiveCurrentUser } from "../contexts/RoleViewOverrideContext";
import { userHasDashboardAccess } from "./roleOnly";

export function DashboardRoleRoute({
  role,
  roles,
  feature,
  action,
  actions,
  requireAdmin,
  requireAllRoles,
  children,
  drivingFleetVehiclesList,
}) {
  const currentUser = useRoleViewEffectiveCurrentUser();
  const currentCompany = useSelector((state) => state.session.currentCompany);
  const navigate = useNavigate();

  const required = useMemo(
    () => (Array.isArray(roles) && roles.length > 0 ? roles : role ? [role] : []),
    [role, roles]
  );

  const needsGuard = drivingFleetVehiclesList || required.length > 0 || Boolean(feature);

  const allowed = userHasDashboardAccess({
    currentUser,
    currentCompany,
    role,
    roles,
    feature,
    action,
    actions,
    requireAdmin,
    requireAllRoles,
    drivingFleetVehiclesList,
  });

  useEffect(() => {
    if (needsGuard && !allowed) {
      navigate("/dashboard");
    }
  }, [
    allowed,
    needsGuard,
    navigate,
  ]);

  if (needsGuard && !allowed) {
    return null;
  }

  return children;
}
